<template>
    <div class="feedback-problem">
        <body-feedback
            :beforeBold='$t("views.feedback.Problem.body[0]")'
            :titleBold='$t("views.feedback.Problem.body[0]")'
            :afterBold='$t("views.feedback.Problem.body[0]")'
            actionName="sendProblem">
            <option-select 
                :options="options"
                typeOption="check"
                itemName="problem"
                :selectMore="true">
            </option-select>
        </body-feedback>
    </div>
</template>
<script>
import BodyFeedback from '../../components/feedback/BodyFeedback.vue'
import OptionSelect from '../../components/Shared/OptionSelect.vue'
import Bus from '../../main.js'
export default {
    components : {
        BodyFeedback,
        OptionSelect
    },
    data(){
        return{
            options : [
                { 
                    value : 0, 
                    text: this.$t("views.feedback.Problem.optionsTexts.body[0]")
                },
                {
                    value : 1,
                    text: this.$t("views.feedback.Problem.optionsTexts.body[0]")
                },
                {
                    value : 2,
                    text: this.$t("views.feedback.Problem.optionsTexts.body[0]")
                },
                {
                    value : 3,
                    text: this.$t("views.feedback.Problem.optionsTexts.body[0]")
                },
                {
                    value : 4,
                    text: this.$t("views.feedback.Problem.optionsTexts.body[0]")
                }
            ]
        }
    },
    created(){
        Bus.$on('sendProblem', this.sendProblem)
    },
    methods:{
        sendProblem(){
            Bus.$emit('nextStep')
            this.$router.push('/feedback-explain')
        }
    }
}
</script>
<style lang="scss" scoped>

</style>
